// extracted by mini-css-extract-plugin
export default {"textInput":"textInput--O6fby","placeholderRow":"placeholderRow--mFJn2"};